module.exports = "/assets/images/left-arrow_00dafd.svg";